import Skeleton from 'react-loading-skeleton';

const SearchResultCardSkeleton = ({ compact = false }) => {
  return (
    <div className="w-full flex items-center justify-between gap-4 p-2.5 rounded-lg border border-border border-l-4 border-l-border">
      {/* Left Side: Text Skeleton */}
      <div className="flex-grow min-w-0">
        <Skeleton height={20} width="70%" />
        {!compact && <Skeleton height={16} width="50%" className="mt-1" />}
      </div>

      {/* Right Side: Badges Skeleton */}
      <div className="flex flex-shrink-0 items-center gap-2">
        {!compact && <Skeleton width={45} height={20} borderRadius={999} />}
        <Skeleton width={55} height={20} borderRadius={999} />
      </div>
    </div>
  );
};

export default SearchResultCardSkeleton;